import Pjax from "pjax"
import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { SocketClient } from "../socket/SocketClient"
import { SocketEvents } from "../../server/socket/SocketEvents"
import { Menu } from "../elements/Menu"

export class PageRestaurantOrderConfirmation implements ClientPage {

  private pjax: Pjax
  private orderId: string | null = null
  private statusChangedHandler: ((...args: any[]) => void) | null = null

  getPageId = (): string => "page-restaurant-order-confirmation"

  execute = (pjax: Pjax): void => {
    this.pjax = pjax

    const confirmationEl = document.querySelector("[data-order-confirmation]") as HTMLElement | null
    if (!confirmationEl) return

    this.orderId = confirmationEl.dataset.orderId || null
    if (!this.orderId) return

    this.clearBasketWhenSettled(confirmationEl)

    SocketClient.emit(SocketEvents.OrderJoin, { orderId: this.orderId })

    const onStatusChanged = (data: { orderId: string; status: string }) => {
      if (data.orderId !== this.orderId) return
      this.pjax.loadUrl(window.location.href)
    }

    SocketClient.on(SocketEvents.OrderUpdated, onStatusChanged)
    this.statusChangedHandler = onStatusChanged
  }

  private clearBasketWhenSettled = (confirmationEl: HTMLElement): void => {
    const storeKey = confirmationEl.dataset.storeKey
    if (!storeKey || confirmationEl.dataset.clearBasket !== "true") return
    try {
      localStorage.removeItem(Menu.getStorageKeyFor(storeKey))
    } catch (error) {
      return
    }
  }

  onPageClose = (): void => {
    if (this.statusChangedHandler) {
      SocketClient.off(SocketEvents.OrderUpdated, this.statusChangedHandler)
    }
  }
}
